import React from "react";
import { Formik, Form, Field, useFormikContext } from "formik";
import * as Yup from "yup";
import { Settings } from "../../../helpers/Contexts";
import { MdClose, MdCheck } from "react-icons/md";

import FieldError from "../../../shared/FieldError";

const LDLCholesterol = ({ data, handleField }) => {
  const LDLCholesterolSchema = Yup.object().shape({
    data: Yup.string()
      .nullable()
      .min(1, "Minimum 1 number characters or more")
      .max(3, "Maximum 3 number characters")
      .matches(/^\d{2,3}$/, "LDL Cholesterol must be an integer"),
  });

  return (
    <Formik
      initialValues={{
        data: data.value,
      }}
      validationSchema={LDLCholesterolSchema}
      onSubmit={async (values) => {
        const request = await handleField({
          id: data.id,
          value: values.data,
          cpr_id: data.cprId,
          quality_measurement_type_id: data.quality_measurement_type_id,
        });

        console.log(request);
      }}
    >
      {({ values, errors, setFieldValue, initialValues }) => {
        return (
          <Form>
            {" "}
            <label>LDL Cholesterol</label>
            <input
              className="default"
              placeholder="e.g. 139"
              value={values.data}
              onChange={(e) => setFieldValue("data", e.target.value)}
            />
            {initialValues.data !== values.data && !errors.data && (
              <div className="check-cancel-buttons flex">
                <button className="check small" type="submit">
                  <MdCheck className="check-icon" />
                </button>
                <button
                  className="cancel small"
                  onClick={() => {
                    initialValues.data
                      ? setFieldValue("data", initialValues.data)
                      : setFieldValue("data", "");
                  }}
                >
                  <MdClose className="cancel-icon" />
                </button>
              </div>
            )}
            {errors.data ? <FieldError error={errors.data} /> : null}
          </Form>
        );
      }}
    </Formik>
  );
};

export default LDLCholesterol;
